var showStardekkFlow = document.getElementById("show-stardekk-flow");;
if (showStardekkFlow) {
    showStardekkFlow.addEventListener("click", () => {
        var stardekkFlowContainer = document.getElementById("stardekk-login-flow");
        var loginDescription = document.getElementById("login-description");
        stardekkFlowContainer.className = "d-block";
        showStardekkFlow.className = "d-none";
        loginDescription.classList = "d-none";    
    });
}